<div class="barcode-button" (click)="showBarcodeClick()">
    <i class="bi bi-credit-card card-icon"></i>
</div>

<div *ngIf="showBarcode" class="fullscreen-popup">

</div>